import { render, staticRenderFns } from "./AboutServiceAPSP.vue?vue&type=template&id=9ef36c2a"
import script from "./AboutServiceAPSP.vue?vue&type=script&lang=ts"
export * from "./AboutServiceAPSP.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports